import { render } from "./LeftPanelComp.vue?vue&type=template&id=1d36a956&scoped=true"
import script from "./LeftPanelComp.vue?vue&type=script&lang=js"
export * from "./LeftPanelComp.vue?vue&type=script&lang=js"

import "./LeftPanelComp.vue?vue&type=style&index=0&id=1d36a956&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d36a956"]])

export default __exports__